export const GET_CONTACT_US_BLOCK_BY_ID_M = (id: string, preview: boolean = false) => `
  query {
    contactUsBlock(id: "${id}", preview: ${preview}) {
        sys {
            id
        }
        heading
        emailHeading
        emailText {
            json
            links {
            entries {
                hyperlink {
                ... on Page {
                    sys {
                    id
                    }
                    slug
                    content {
                    __typename
                    }
                }
                }
            }
            }
        }
        phoneHeading
        phoneText {
            json
            links {
                entries {
                    hyperlink {
                        ... on Page {
                            sys {
                                id
                            }
                            slug
                            content {
                                __typename
                            }
                        }
                    }
                }
            }
        }
        showBusyIndicator
        phoneHoursHeading
        phoneHoursText{
            json
            links {
                entries {
                    hyperlink {
                        ... on Page {
                            sys {
                                id
                            }
                            slug
                            content {
                                __typename
                            }
                        }
                    }
                }
            }
        }
        showDeviatingOpeningHours
        deviatingOpeningHoursHeading
        deviatingOpeningHoursMessage
        deviatingOpeningHoursStartDate
        deviatingOpeningHoursEndDate
        postHeading
        postText{
            json
            links {
                entries {
                    hyperlink {
                        ... on Page {
                            sys {
                                id
                            }
                            slug
                            content {
                                __typename
                            }
                        }
                    }
                }
            }
        }
        visitorHeading
        visitorText{
            json
            links {
                entries {
                    hyperlink {
                        ... on Page {
                            sys {
                                id
                            }
                            slug
                            content {
                                __typename
                            }
                        }
                    }
                }
            }
        }
        visitorHoursHeading
        visitorHoursText{
            json
            links {
                entries {
                    hyperlink {
                        ... on Page {
                            sys {
                                id
                            }
                            slug
                            content {
                                __typename
                            }
                        }
                    }
                }
            }
        }
        richText {
            json
            links {
                entries {
                    hyperlink {
                    ... on Page {
                        sys {
                        id
                        }
                        slug
                        content {
                        __typename
                        }
                    }
                    }
                }
            }
        }
    }
  }`;
